import api from "../api/axios";
import { getAuthHeaders, requestWithRefresh } from "../Utils/apiUtils";

import { CreateApplicantActivity } from "../Types/Applicants/ApplicantsActivity";

export const APPLICANT_ACTIVITY_QUERY_KEY = ["appl-activity"];

export const applicantActivityService = {
  createActivity: (payload: CreateApplicantActivity) =>
    requestWithRefresh(() =>
      api
        .post("api/appl-activity", payload, {
          headers: getAuthHeaders(),
        })
        .then((res) => res.data),
    ),
  GetByApplNo: async (application_no: string) =>
    requestWithRefresh(() =>
      api
        .get(`api/appl-activity/${application_no}/appl-no`, {
          headers: getAuthHeaders(),
        })
        .then((res) => res.data.data),
    ),
  toggleStatus: async (id: number) =>
    requestWithRefresh(() =>
      api
        .patch(`api/appl-activity/${id}/toggle-status`, {
          headers: getAuthHeaders(),
        })
        .then((res) => res.data),
    ),
};
